import { Link } from 'react-router';

import { IMG, ACHIEVEMENTS, PHONE_NUMBERS } from '../../const';
import { routes } from '../../const/routes';
import quickQuotLogo from '../../assets/images/laEstimator_powered_white.svg';
import './footer.scss';

const Footer = () => {
  const date = new Date();

  return (
    <footer itemScope itemType="http://schema.org/Organization">
      <nav>
        <div className="quick-quot-logo">
          <img src={quickQuotLogo} alt="LaEstimator" width="226" height="28" />
          <Link to={routes.landingPage} title="Home" />
          <a
            href="https://lasoft.org/"
            title="Lasoft Innovation Lab"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </nav>
      <div itemScope="" itemType="http://schema.org/LocalBusiness">
        <div>
          <dl>
            <dt>Visit us</dt>
            <dd
              itemProp="address"
              itemScope
              itemType="http://schema.org/PostalAddress"
            >
              <a
                href="https://maps.app.goo.gl/Tbfb2K9S5vLME5o69"
                target="_blank"
                rel="noreferrer nofollow"
              >
                <span className="nobr">
                  <span itemProp="addressLocality">Washington, DC </span>{' '}
                  <span itemProp="postalCode">20036</span>,{' '}
                  <span itemProp="addressCountry">USA</span>
                </span>
              </a>
            </dd>
            <dd
              itemProp="address"
              itemScope
              itemType="http://schema.org/PostalAddress"
            >
              <a
                href="https://maps.app.goo.gl/whFPimQakEUTsnks9"
                target="_blank"
                rel="noreferrer nofollow"
              >
                <span className="nobr">
                  <span itemProp="addressLocality">Zürich, </span>{' '}
                  <span itemProp="addressCountry">Switzerland</span>
                </span>
              </a>
            </dd>
            <dd
              itemProp="address"
              itemScope
              itemType="http://schema.org/PostalAddress"
            >
              <a
                href="https://maps.app.goo.gl/MCsRQq7XJe3enmts7"
                target="_blank"
                rel="noreferrer nofollow"
              >
                <span itemProp="streetAddress">
                  148/150 Piotrkowska&nbsp;st.
                </span>
                ,{' '}
                <span className="nobr">
                  <span itemProp="postalCode">90-063&nbsp;</span>{' '}
                  <span itemProp="addressLocality">Łódź</span>,{' '}
                  <span itemProp="addressCountry">Poland</span>
                </span>
              </a>
            </dd>
            <dd
              itemProp="address"
              itemScope
              itemType="http://schema.org/PostalAddress"
            >
              <a
                href="https://maps.app.goo.gl/B6RdSzCCwEm2drnm9"
                target="_blank"
                rel="noreferrer nofollow"
              >
                <span itemProp="streetAddress">7 Muchna st.</span>,{' '}
                <span className="nobr">
                  <span itemProp="postalCode">79014&nbsp;</span>{' '}
                  <span itemProp="addressLocality">Lviv</span>,{' '}
                </span>{' '}
                <span itemProp="addressCountry">Ukraine</span>
              </a>
            </dd>
          </dl>
          <dl>
            <dt>Call us</dt>
            {PHONE_NUMBERS.map((item) => (
              <dd
                itemProp="contactPoint"
                itemScope=""
                itemType="http://schema.org/ContactPoint"
                key={item.id}
              >
                <a
                  href={`tel:${item.phone}`}
                  target="_blank"
                  rel="noreferrer nofollow"
                  className="phoneLink"
                >
                  <img
                    src={`${IMG.ALL_FLAGS}${item.id}.svg`}
                    alt={item.country}
                    width="18"
                    height="12"
                    className="phoneFlag"
                  />
                  <span itemProp="telephone" content={item.phone}>
                    {item.phone}
                  </span>
                </a>
              </dd>
            ))}
          </dl>
          <dl>
            <dt>Email us</dt>
            <dd
              itemProp="contactPoint"
              itemScope=""
              itemType="http://schema.org/ContactPoint"
            >
              <a
                href="mailto:info@lasoft.org"
                itemProp="email"
                content="info@lasoft.org"
                rel="nofollow"
              >
                info@lasoft.org
              </a>
            </dd>
          </dl>
          <dl>
            <dt>Achievements</dt>
            <dd>
              <ul className="achievements">
                {ACHIEVEMENTS.map((item) => (
                  <li key={item.id}>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noreferrer noopener nofollow"
                    >
                      <picture>
                        <source
                          srcSet={`${IMG.ABOUT}/${item.id}.avif`}
                          type="image/avif"
                        />
                        <source
                          srcSet={`${IMG.ABOUT}/${item.id}.webp`}
                          type="image/webp"
                        />
                        <img
                          src={`${IMG.ABOUT}/${item.id}.png`}
                          alt={item.text}
                          width="52"
                          height="52"
                          loading="lazy"
                        />
                      </picture>
                    </a>
                  </li>
                ))}
              </ul>
            </dd>
          </dl>

          <dl>
            <dt>Follow us</dt>
            <dd>
              <ul className="socialNetworks">
                <li>
                  <a
                    href="https://www.facebook.com/lasoftians/"
                    title="LaSoft in Facebook"
                    className="social__Facebook"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/la'soft-"
                    title="LaSoft in LinkedIn"
                    className="social__LinkedIn"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in LinkedIn</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.behance.net/lasoft"
                    title="LaSoft in Behance"
                    className="social__Behance"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in Behance</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://dribbble.com/LaSoft"
                    title="LaSoft in Dribbble"
                    className="social__Dribbble"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in Dribbble</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://clutch.co/profile/lasoft"
                    title="LaSoft in Clutch"
                    className="social__Clutch"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in Clutch</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.designrush.com/agency/profile/lasoft"
                    title="LaSoft in DesignRush"
                    className="social__DesignRush"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in DesignRush</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCGiINdBnqPoBpK1WaCEZMHQ/featured?sub_confirmation=1"
                    title="LaSoft in YouTube"
                    className="social__YouTube"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in YouTube</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/lasoftians/"
                    title="LaSoft in Instagram"
                    className="social__Instagram"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    <span>LaSoft in Instagram</span>
                  </a>
                </li>
              </ul>
            </dd>
          </dl>
        </div>
        <div className="bottomLinks">
          <p>
            <Link to={routes.privacyPolicy}>Privacy Policy</Link>
            <Link to={routes.termsOfUse}>Terms of Use</Link>
          </p>
          <p>Copyright © {date.getFullYear()} LaSoft. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
